import { combineReducers } from 'redux'
import { routerReducer as router } from 'react-router-redux'

import error from './error'
import { lineitems } from './lineitems'
import { filter } from './filter'
import { searchbar } from './searchbar'
import { project } from './project'
import { auth } from './auth'

const rootReducer = combineReducers({
  router,
  auth,
  lineitems,
  filter,
  searchbar,
  project,
  error
})

export default rootReducer